import { PricingTiers } from "@/components/PricingTiers";

export default function Pricing() {
  return (
    <main className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-testid="pricing-page">
      <p className="label-caps text-emerald-400">Subscription tiers</p>
      <h1 className="font-display mt-3 text-4xl font-black uppercase tracking-tight text-white sm:text-5xl">Choose your edge</h1>
      <p className="mt-3 max-w-xl text-sm text-slate-400">Secure checkout by Stripe. Cancel anytime. Test mode: use card 4242 4242 4242 4242.</p>
      <div className="mt-10"><PricingTiers /></div>
    </main>
  );
}
